import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from './api';
import { peekSession, clearPeek } from '../utils/peek';

/** Fixed bottom bar shown while a platform admin is peeking into an org. Renders nothing otherwise. */
function PeekBanner() {
  const navigate = useNavigate();
  const [session, setSession] = useState(peekSession());

  // Re-read every 30s so the countdown ticks and an expired session drops the banner
  useEffect(() => {
    const id = setInterval(() => setSession(peekSession()), 30000);
    const onStorage = () => setSession(peekSession());
    window.addEventListener('peek-changed', onStorage);
    return () => { clearInterval(id); window.removeEventListener('peek-changed', onStorage); };
  }, []);

  if (!session) return null;

  const minutesLeft = Math.max(0, Math.round((session.expiresAtMs - Date.now()) / 60000));

  const handleExit = async () => {
    try {
      await axiosInstance.post('/admin/orgs/peek/exit');
    } catch (e) {
      // best-effort audit event; the session is cleared regardless
    }
    clearPeek();
    setSession(null);
    navigate('/adminHome/organisations');
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14,
      padding: '9px 16px', background: '#92400e', color: '#fef3c7',
      fontSize: 14, fontWeight: 600, boxShadow: '0 -2px 10px rgba(0,0,0,0.35)',
    }}>
      <i className="fas fa-eye" />
      <span>
        Viewing <strong>{session.orgName}</strong> as Platform Admin
        {minutesLeft > 0 && <span style={{ fontWeight: 400, opacity: 0.85 }}> — expires in {minutesLeft} min</span>}
      </span>
      <button onClick={handleExit} style={{
        background: '#fef3c7', color: '#92400e', border: 'none', borderRadius: 6,
        padding: '4px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
      }}>
        <i className="fas fa-right-from-bracket" style={{ marginRight: 6 }} />Exit
      </button>
    </div>
  );
}

export default PeekBanner;
